/**
 * DateSeparator Component
 * 
 * Displays date headers between messages from different days.
 * Shows: "Today", "Yesterday", "Monday", "January 5, 2026"
 */

import React from 'react';
import { formatDateSeparator } from './utils/timeFormat';

export default function DateSeparator({ timestamp }) {
  const label = formatDateSeparator(timestamp);

  return (
    <div className="flex items-center justify-center my-4">
      <div data-ui="date-sep" className="bg-slate-100 dark:bg-[#3a3d41] text-slate-500 dark:text-slate-400 text-xs font-medium px-3 py-1 rounded-full">
        {label}
      </div>
    </div>
  );
}
